import { Directive, OnInit, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { RLBaseComponent } from '../rl-base-component/rl-base.component';

@Directive()
export abstract class ContainerComponent extends RLBaseComponent implements OnInit {
    protected readonly document: Document = inject(DOCUMENT);

    public ngOnInit(): void {
        this.document.getElementById('splash')?.remove();
    }
}
